import { useMemo } from 'react';

import { Chip, ChipProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { HospiceChipStyles } from 'src/constants/ChipStyles';
import { HospiceStatus, HospiceStatusLabels } from 'src/constants/HospiceStatus';

export interface HospiceChipProps {
    hospiceStatus: HospiceStatus;
    hideLabel?: boolean;
}

const HospiceChip = (props: HospiceChipProps) => {
    const { hospiceStatus, hideLabel = false } = props;
    const { spacing } = useTheme();

    const chipProps = useMemo<ChipProps>(() => {
        const style = HospiceChipStyles[hospiceStatus] ?? HospiceChipStyles[HospiceStatus.UNKNOWN];
        const label = !hideLabel ? HospiceStatusLabels[hospiceStatus] : undefined;
        const sxProp = hideLabel
            ? {
                  '&.MuiChip-root': {
                      minHeight: spacing(3.75),
                  },
                  '& .MuiChip-label': { display: 'none' },
              }
            : undefined;

        return {
            ...style,
            label,
            sx: sxProp,
        };
    }, [hospiceStatus, hideLabel, spacing]);

    return <Chip {...chipProps} />;
};

export default HospiceChip;
